import { render } from "./TechStackPage.vue?vue&type=template&id=50d279cb&scoped=true"
import script from "./TechStackPage.vue?vue&type=script&lang=js"
export * from "./TechStackPage.vue?vue&type=script&lang=js"

import "./TechStackPage.vue?vue&type=style&index=0&id=50d279cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d279cb"]])

export default __exports__